var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 32,
    rx: 16,
    fill: "#636363"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5781 20.1406C40.0215 20.1406 41.5391 18.459 41.5391 15.7754V15.7637C41.5391 13.0859 40.0156 11.4043 37.5781 11.4043C35.1465 11.4043 33.6172 13.0801 33.6172 15.7637V15.7754C33.6172 18.4648 35.1406 20.1406 37.5781 20.1406ZM37.5781 18.9805C35.9727 18.9805 34.9531 17.7441 34.9531 15.7754V15.7637C34.9531 13.7949 35.9785 12.5645 37.5781 12.5645C39.1836 12.5645 40.1973 13.8008 40.1973 15.7637V15.7754C40.1973 17.7266 39.2012 18.9805 37.5781 18.9805ZM42.793 20H44.1055V16.4609H47.7383V15.3535H44.1055V12.6758H48.0723V11.5449H42.793V20ZM49.2148 20H50.5273V16.4609H54.1602V15.3535H50.5273V12.6758H54.4941V11.5449H49.2148V20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOff);
export default __webpack_public_path__ + "static/media/switch-off.e6d5f109.svg";
export { ForwardRef as ReactComponent };